/* unplugin-vue-components disabled */import { render } from "./atlasAssembly.vue?vue&type=template&id=9310046c&scoped=true"
import script from "./atlasAssembly.vue?vue&type=script&lang=js"
export * from "./atlasAssembly.vue?vue&type=script&lang=js"

import "./atlasAssembly.vue?vue&type=style&index=0&id=9310046c&scoped=true&lang=css"

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9310046c"]])

export default __exports__